import React,{useEffect} from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MembershipMain from './MembershipMain';

const Membership = () => {
    useEffect(() => {
      document.title = "Registration | Society of Aquaculture Professionals";
    }, []);
  return (
    <div>
      <>
        <Header />

        <MembershipMain />

        <Footer />
      </>
    </div>
  );
};
export default Membership;
